<template>
  <div class="blankBox afterLoanList clearfix">
    <div class="serchFilter">
      <table border="0" cellpadding="0" cellspacing="0">
        <tr>
          <td><label>{{ $t('loan.applyCompany')+'：' }}</label></td>
          <td><el-input :placeholder="$t('financing.pleaseWrite')" v-model.trim="searchForm.companyName" clearable class="w-250"/></td>
          <td style="padding-left:10px;"><label>{{ $t('financingFundList.applyStatusTr')+'：' }}</label></td>
          <td>
            <el-select v-model="statusArr" :placeholder="$t('accountcenter.plsChoice')" multiple class="w-250" @change="statusChange">
              <el-option v-for="(item, index) in statusData" :key="index" :label="$t(`allorders_status.${item}`)" :value="item"/>
            </el-select>
          </td>
        </tr>
        <tr>
          <td><label>{{ $t('financing.startTime')+'：' }}</label></td>
          <td>
            <el-date-picker v-model="startTime" :placeholder="$t('loan.selectTime')" format="yyyy-MM-dd" class="w-250" type="date"/>
          </td>
          <td style="padding-left:10px;"><label>{{ $t('financing.endTime')+'：' }}</label></td>
          <td>
            <el-date-picker v-model="endTime" :placeholder="$t('loan.selectTime')" format="yyyy-MM-dd" class="w-250" type="date"/>
          </td>
        </tr>
        <tr>
          <td><label>{{ $t('flowLists.flowNumber')+'：' }}</label></td>
          <td>
            <el-input :placeholder="$t('financing.pleaseWrite')" v-model.trim="searchForm.flowNumber" clearable class="w-250"/>
          </td>
        </tr>
      </table>
      <div style="text-align:center;margin:0 auto 30px;">
        <el-button type="primary" style="width: 150px;" @click="query">{{ $t('financing.view') }}</el-button>
      </div>
    </div>

    <el-table :data="dataList" class="dataTable">
      <!--          <el-table-column type="index" :label="$t('contractManage.orderNum')" width="80" align="center"></el-table-column>-->
      <el-table-column :label="$t('contractManage.orderNum')" width="50" align="left">
        <template slot-scope="scope">
          <span>{{ ((page.pageNo-1) * page.rows) + scope.$index+1 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('common.applyDate')" width="125">
        <template slot-scope="scope">{{ scope.row.applyTime | dateConvert }}</template>
      </el-table-column>
      <!--      申请日期-->

      <el-table-column :label="$t('flowLists.flowNumber')" prop="flowNumber" width="160"/>
      <el-table-column :label="$t('loan.applyCompany')" :show-overflow-tooltip="true" prop="applyCompany" width="170"/>
      <el-table-column :label="$t('loan.loanAmountList')+'(US$)'" width="145">
        <template slot-scope="scope">{{ scope.row.financingMoney | formatNum }}</template>
      </el-table-column>
      <el-table-column :label="$t('loan.dateOfDate')" width="150">
        <template slot-scope="scope">
          <p v-for="(item,index) in scope.row.zmaCreditStatusList" :key="index" class="item">{{ item.financingTime | dateConvert }}</p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('loan.refundAmount')" width="145">
        <template slot-scope="scope">US$ {{ scope.row.shipRepaymentAmount | formatNum }}</template>
      </el-table-column>
      <el-table-column :label="$t('loan.dueDate')" width="100">
        <template slot-scope="scope">
          <p v-for="(item,index) in scope.row.zmaCreditStatusList" :key="index" class="item">{{ item.repaymentTime | dateConvert }}</p>
        </template>
      </el-table-column>
      <!-- 申请状态 -->
      <el-table-column :label="$t('loan.status')" width="200" align="left" fixed="right">
        <template v-if="scope.row.applicationStatusList.length" slot-scope="scope">

          <p v-for="(statusItem,index) in scope.row.applicationStatusList" v-if="[100,101,1001,1002].indexOf(statusItem.status)==-1" :key="index" class="item">

            <template v-if="statusItem.loanType==1">
              <span >NO{{ statusItem.sort }} </span>{{ $t(`allorders_status.${statusItem.status}`) }}
              <div v-for="(v,i) in statusItem.creditStatuses" :key="i" style="padding-left:30px;">{{ $t('newrisk.s_ship_data')+ v.sort }}</div>
            </template>
            <template v-if="statusItem.loanType==2">
              <span >NO{{ statusItem.sort }} </span>{{ $t(`allorders_status.${statusItem.status}`) }}
            </template>
            <template v-if="statusItem.loanType==3">
              <span >NO{{ statusItem.sort }} </span>{{ $t(`allorders_status.${statusItem.status}`) }}
              <div v-for="(v,i) in statusItem.creditStatuses" :key="i" style="padding-left:30px;">NO{{ v.sort }}{{ $t(`allorders_status.${v.status}`) }}</div>
            </template>
            <template v-if="!statusItem.loanType">
              {{ $t(`allorders_status.${statusItem.status}`) }}
            </template>

          </p>
        </template>
      </el-table-column>
      <!-- 功能 -->
      <el-table-column :label="$t('contractManage.function')" width="90" align="center" fixed="right">
        <template slot-scope="scope">
          <p class="item">
            <router-link v-if="isView(scope.row.statusList)" :to="`/loanDetail?f_n=${scope.row.flowNumber}&menuType=4`" class="btn-link">{{ $t('btns.view') }}</router-link>
            <!-- 查看 -->
            <router-link v-if="isAudit(scope.row.statusList)" :to="`/loanDetail?f_n=${scope.row.flowNumber}&menuType=4`" class="btn-link">{{ $t('btns.audit') }}</router-link>
            <!-- 审核 -->
            <router-link v-if="isApply(scope.row.statusList)" :to="`/loanDetail?f_n=${scope.row.flowNumber}&menuType=4`" class="btn-link">{{ $t('btns.apply') }}</router-link>
            <!-- 申请 -->
          </p>
        </template>
      </el-table-column>
      <template slot="empty">
        <div class="statusEmpty"><i/>{{ $t('financing.noData') }}</div>
      </template>
    </el-table>
    <el-pagination
      v-show="page.total"
      :total="page.total"
      :page-size="page.rows"
      :current-page.sync="page.pageNo"
      class="page-theme"
      background
      layout="prev, pager, next"
      style="text-align: center;padding-top:30px; padding-bottom: 30px; "
      @current-change="sizeChange"/>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import api from '../api'
import mixins from '@/helper/mixins.js'
export default {
  name: 'AfterLoanList',
  mixins: [mixins],
  data() {
    return {
      api,
      hideStatus: [100, 101], // 需要隐藏船期的状态
      btnLimit: [], // 按钮权限集合
      page: {
        pageNo: 1, // 当前页数
        rows: 10,
        total: 0
      }, // 分页数据

      statusData: ['0', '120', '140', '150', '160', '170', '1009', '1011', '1012', '1013', '1099', '180'], // 申请状态列表数据
      dataList: [], // 列表数据
      // times: [
      //   dayjs(dayjs().subtract(30, "day").format('YYYY-MM-DD')+'00:00:00').toDate(),
      //   dayjs(dayjs().format('YYYY-MM-DD')+'23:59:59').toDate()
      // ],  // 申请时间
      startTime: dayjs(dayjs().subtract(12, 'month').format('YYYY-MM-DD') + ' 00:00:00').toDate(),
      endTime: dayjs(dayjs().format('YYYY-MM-DD') + ' 23:59:59').toDate(),
      statusArr: [],
      searchForm: {
        companyName: '', // 申请公司
        statusList: '', // 申请状态
        flowNumber: '' //  流水号
      }
    }
  },
  mounted() {
    document.title = this.$t('loanApplication.loanfollow')

    const isSuper = this.isSuper()
    if (isSuper) { // 如果是超级管理员 所有的权限都会有
      this.btnLimit = [1, 140, 150, 160]
    } else {
      this.getMenuLimit(4).then(data => {
        this.btnLimit = data
      }) // 获取贷后跟踪下的操作按钮权限
    }

    this.getList()
  },

  methods: {
    /**
       * 申请状态下拉选择监听
       * @param val
       */
    statusChange(val) {
      const _this = this
      const len = val.length

      if (val[len - 1] == '0') {
        _this.statusArr = []
        _this._.map(_this.statusData, (val, key) => {
          _this.statusArr.push(key)
        })
      } else {
        _this._.pull(_this.statusArr, '0') // 去掉全部0
      }
    },

    /**
       * 判断是否有 融资完成 180
       */
    isComplete(arr) {
      const result = this._.find(arr, { 'applicationStatus': 180 })
      return !!result
    },

    /**
       * 查询列表
       */
    query() {
      this.page.pageNo = 1
      this.getList()
    },

    /**
       * pageSize 分页事件
       * @param curPage 当前页
       */
    sizeChange(curPage) {
      this.page.pageNo = curPage
      this.getList()
    },

    /**
       * 获取列表数据
       */
    getList() {
      // console.log(this.times);
      const params = {
        companyName: this.searchForm.companyName,
        statusList: this.statusArr.indexOf('0') > -1 || this.statusArr.length < 1 ? '0' : this.statusArr.toString(),
        flowNumber: this.searchForm.flowNumber,
        page: this.page.pageNo,
        rows: this.page.rows
      }
      // console.log(this.startTime);
      // console.log(dayjs(dayjs(this.endTime).format('YYYY-MM-DD')+' 23:59:59').toDate());
      if (this.startTime) {
        params.startTime = this.startTime.toString()
      }
      if (this.endTime) {
        params.endTime = dayjs(dayjs(this.endTime).format('YYYY-MM-DD') + '23:59:59').toDate().toString()
      }
      // console.log(params);
      this.axios.post(this.api.afterLoanList, params).then(res => {
        // console.log(res);
        if (res.status) {
          this.dataList = res.data.rows.length > 0 ? res.data.rows : []
          this.page.total = res.data.total
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`))
        }
      })
    },

    isView(statusList) {
      statusList = Array.isArray(statusList) ? statusList : []
      if (this.btnLimit.indexOf(1) > -1 && (!this.isAudit(statusList)) && (!this.isApply(statusList))) {
        return true
      } else {
        return false
      }
    }, // 是否展示查看

    isAudit(statusList) {
      statusList = Array.isArray(statusList) ? statusList : []
      return this._.some(statusList, (val) => {
        // console.log(val);
        const status = parseInt(val.applicationStatus)
        if ((status == 150 && this.btnLimit.indexOf(150) > -1) || (status == 160 && this.btnLimit.indexOf(160) > -1)) {
          return true
        } else {
          return false
        }
      })
    }, // 是否展示审核

    isApply(statusList) {
      statusList = Array.isArray(statusList) ? statusList : []
      return this._.some(statusList, (val) => {
        const status = parseInt(val.applicationStatus)
        if (status == 140 && this.btnLimit.indexOf(140) > -1) {
          return true
        } else {
          return false
        }
      })
    } // 是否展示申请
  }
}
</script>

